import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { OrganizationDto } from '../../../../../modules/organizations/dto/organization.dto';

@Component({
	selector: 'app-deactivate-organization-modal',
	styles: [],
	templateUrl: './deactivate-organization-modal.component.html',
})
export class DeactivateOrganizationModalComponent {
	constructor(
		public dialogRef: MatDialogRef<DeactivateOrganizationModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: { organization: OrganizationDto },
	) {}

	closeModal(): void {
		this.dialogRef.close(false);
	}

	confirm(): void {
		this.dialogRef.close(true);
	}
}
